import compact from 'lodash/compact';
import { StringPlacement } from './resolvePlacement';
import { BANK_ID, DnDToken, Placement, SlotConfig } from './types';

type BuildStringPlacementArgs = {
  tokens: DnDToken[];
  slots: SlotConfig[];
  placement: Placement;
};

export function buildStringPlacement({
  tokens,
  slots,
  placement,
}: BuildStringPlacementArgs): StringPlacement {
  const slotPlacement = Object.fromEntries(
    slots.map(
      slot => [slot.id, (placement[slot.id] ?? []).map(String)] as const,
    ),
  );

  const placedInSlots = new Set(Object.values(slotPlacement).flat());
  const unplacedIds = tokens
    .map(token => String(token.id))
    .filter(id => !placedInSlots.has(id));
  const unplacedSet = new Set(unplacedIds);

  const storedBank = (placement[BANK_ID] ?? [])
    .map(String)
    .filter(id => unplacedSet.has(id));
  const storedSet = new Set(storedBank);
  const bankOrder = [
    ...storedBank,
    ...unplacedIds.filter(id => !storedSet.has(id)),
  ];

  return { ...slotPlacement, [BANK_ID]: bankOrder };
}

export function toPlacement(
  stringPlacement: StringPlacement,
  tokenById: Map<string, DnDToken>,
): Placement {
  const entries = Object.entries(stringPlacement).map(
    ([containerId, ids]) =>
      [containerId, compact(ids.map(id => tokenById.get(id)?.id))] as const,
  );

  return Object.fromEntries(entries);
}
